import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <span>&copy; {new Date().getFullYear()} Vector Tuner</span>
        <a href="/privacy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
      </div>
    </footer>
  );
} 